import { IDeviceStrategy, DeviceInfo, SessionOptions } from './IDeviceStrategy';

export class LowMemoryDeviceStrategy implements IDeviceStrategy {
  getDeviceInfo(): DeviceInfo {
    const nav = navigator as any;
    const memory = nav.deviceMemory || nav.hardwareConcurrency || 4;
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
    const isSlowConnection = connection && (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g');
    
    return {
      estimatedRAM: memory,
      isLowMemory: true,
      isSlowConnection: isSlowConnection
    };
  }

  getSessionOptions(_debug: boolean): SessionOptions {
    return {
      executionProviders: ['wasm'],
      graphOptimizationLevel: 'basic',
      logSeverityLevel: 4,
      logVerbosityLevel: 0,
      enableCpuMemArena: false,
      enableMemPattern: false,
      executionMode: 'sequential',
      interOpNumThreads: 1,
      intraOpNumThreads: 1,
    };
  }

  shouldUseSequentialLoading(): boolean {
    return true;
  }
}